import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import UserSearch from '../user-search'

class EventRiders extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: undefined
    }
  }

  getRiderStatusMessage(status) {
    return {
      'completed': 'Confirmed',
      'pending': 'Rider request sent'
    }[status]
  }

  renderRider(rider, index) {
    const className = (status) => classnames({
      'event-rider': true,
      'event-rider--completed': status === 'completed'
    })

    const statusMessage = this.getRiderStatusMessage(rider.status)

    return rider.status === 'pending'
      ? <li key={index} className={className(rider.status)} onClick={() => this.props.setModal('EventDeleteRiderRequestModal', {riderRequest: {...rider, statusMessage}})}>
          <span className="status">{statusMessage}</span>
          <span className="title">{rider.title}</span>
        </li>
      : <li key={index} className={className(rider.status)}>
          <Link to={`/rider/${rider.id}`} target="_blank">
            <span className="status">{statusMessage}</span>
            <span className="title">{rider.title}</span>
          </Link>
        </li>
  }

  renderStageRiders(stage, index = null) {
    const { view } = this.props
    const { riders } = stage
    const riderRequests = stage.rider_requests

    return (
      <div key={index} className="subsection">
        <h3>{stage.title}</h3>

        <ul>
          {
            riders.map((rider, index) => this.renderRider({...rider, status: 'completed'}, index))
          }

          {
            riderRequests.map((request, index) => {
              if (request.status !== 'completed') return this.renderRider(request, index)
            })
          }

          {
            view.editable
            ? <li className="event-rider event-rider--add" onClick={() => this.props.setModal('EventCreateRiderRequestModal', {stage})}>
                Request a rider
              </li>
            : null
          }
        </ul>
      </div>
    )
  }

  render() {
    const { eventId, stage, stages, riderRequests } = this.props

    return (
      <section className="event-riders">
        {
          stage.id
          ? this.renderStageRiders(stage)
          : stages.length > 0
            ? stages.map((stage, index) => this.renderStageRiders(stage, index))
            : <div>
                To request riders, start by <a onClick={() => this.props.setModal('EventStageCreateModal', {eventId})}>adding a stage</a>.
              </div>
        }
      </section>
    )
  }
}

EventRiders.propTypes = {
  view: PropTypes.object,
  eventId: PropTypes.string,
  stage: PropTypes.object,
  stages: PropTypes.array,
  deleteRiderRequest: PropTypes.func,
  setModal: PropTypes.func
}

EventRiders.defaultProps = {
  view: {},
  eventId: undefined,
  stage: {},
  stages: [],
  deleteRiderRequest: function() {},
  setModal: function() {}
}

export default EventRiders



// WEBPACK FOOTER //
// ./src/components/event/event-riders/riders.js